import type { infer as zInfer } from "zod/v4";
import { object, string } from "zod/v4";

export const getRivoIntegration = {
  name: "getRivoIntegration" as const,
  input: object({}),
  output: object({
    rivoIntegration: object({ rewardsPageUrl: string().nullish() }).optional(),
  }),
};

export type RivoIntegration = zInfer<typeof getRivoIntegration.output>;
